/* @flow */

import {createAction} from 'redux-act';

import type {ChatReportDataRequestedAction} from '../types';

/*
 * Action creators
 */
export const requestReportData: (
    payload: $PropertyType<ChatReportDataRequestedAction, 'payload'>
) => ChatReportDataRequestedAction = createAction('CHAT_REPORT_DATA_REQUESTED');
export const updateReportChartData = createAction('CHAT_REPORT_CHART_DATA_UPDATED');
export const updateReportMaps = createAction('CHAT_REPORT_MAPS_UPDATED');
export const failReportChartData = createAction('CHAT_REPORT_CHART_DATA_FAILED');
